<template>
    <a-card size="small" title="KA私用环境管理">
        <a-button type="primary" slot="extra" @click="handleNew">新建</a-button>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
            <a-form-item label="关键字">
                <a-input v-model="searchP.keyword" placeholder="请输入关键字"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getAppSumData">查询</a-button>
            </a-form-item>

            <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
            </a-form-item>
        </a-form>
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="tableData" class="mt20" :scroll="{ x: clientWidth}" :pagination="false" :loading="tloading" rowKey="id">

            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a-dropdown>
                        <a-button type="primary" @click="e => {e.preventDefault()}"> 操作
                            <a-icon type="down" />
                        </a-button>
                        <a-menu slot="overlay" @click="handleMenuClick($event,record)">
                            <a-menu-item key="env_edit">
                                编辑环境
                            </a-menu-item>
                            <a-menu-item key="env_middle">
                                中间件管理
                            </a-menu-item>
                            <a-menu-item key="env_domain">
                                域名管理
                            </a-menu-item>
                            <!-- <a-menu-item key="env_res">
                            资源配置
                        </a-menu-item> -->
                            <a-menu-item key="env_sys">
                                关联系统
                            </a-menu-item>
                            <a-menu-item key="env_jenkins">
                                同步Jenkins
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>

                    <a-popconfirm v-show="record.status == 1" title="确认销毁环境?" @confirm="() => onDelete(record)">
                        <a-button class="ml20">销毁环境</a-button>
                    </a-popconfirm>
                </div>

            </template>

        </a-table>
        <a-pagination class="my_pagenation" v-model="pagination.page" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

        <itemModal ref="myItemModal" @onModalHide="onModalHide"></itemModal>

    </a-card>
</template>
<script>
import itemModal from './item.vue'
let pagination = {
    total: 0,
    pageSize: 0,
    current: 1,
}

let status = {
    0: '未使用',
    1: '使用中',
    2: '已销毁',
}
const columns = [
    {
        title: '序号',
        width: 80,
        align: 'center',
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination
            return (Number(current) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: 'KA客户名称',
        dataIndex: 'kadesc',
        align: 'center',
        width: 200,
    },
    {
        title: 'KA客户编码',
        dataIndex: 'kacode',
        align: 'center',
        width: 100,
    },
    {
        title: 'KA客户环境编码',
        dataIndex: 'kaenv',
        align: 'center',
        width: 120,
    },
    {
        title: '状态',
        dataIndex: 'status',
        align: 'center',
        customRender: (text) => {
            return status[text]
        },
        width: 80,
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 250,
        fixed: 'right',
        scopedSlots: { customRender: 'operation' },
    },
]
export default {
    components: {
        itemModal,
    },
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            tableData: [],
            tloading: false,
            clientWidth: 800,
            pagination,
            searchP: {
                keyword: '',
            },
            queryHandller: null,
            taskid: '',
            tempParams: {},
        }
    },
    methods: {
        //操作菜单点击
        handleMenuClick(e, record) {
            // e.preventDefault()
            switch (e.key) {
                case 'env_edit':
                    //编辑
                    this.handleEdit(record)
                    break
                case 'env_middle':
                    //中间件管理
                    this.handleMiddleware(record)
                    break
                case 'env_domain':
                    //域名管理
                    this.handleBindDomain(record)
                    break
                // case 'env_res':
                //     //资源配置
                //     this.handleBindRes(record)
                //     break;
                case 'env_sys':
                    //资源配置
                    this.handleBindSys(record)
                    break
                case 'env_jenkins':
                    //jenkins配置
                    this.handleSync(record)
                    break
                default:
                    break
            }
            console.log(record)
        },
        handleMiddleware(record) {
            this.$router.push({
                path: 'middleware',
                query: {
                    kaenv: record.kaenv,
                    kadesc: record.kadesc,
                },
            })
        },
        //域名管理
        handleBindDomain(record) {
            this.$router.push({
                path: 'domain',
                query: {
                    kaenv: record.kaenv,
                    kadesc: record.kadesc,
                },
            })
        },
        //资源配置
        handleBindRes(record) {
            this.$router.push({
                path: 'resource',
                query: {
                    kaenv: record.kaenv,
                    kadesc: record.kadesc,
                },
            })
        },

        //绑定系统
        handleBindSys(record) {
            this.$router.push({
                path: 'bindsys',
                query: {
                    kaenv: record.kaenv,
                    kadesc: record.kadesc,
                },
            })
        },
        //同步jenkins
        handleSync(record) {
            let that = this
            this.$store
                .dispatch({
                    type: 'kamanager/syncjenkins',
                    params: {
                        kaenv: record.kaenv,
                    },
                })
                .then((res) => {
                    if (res.data.success == 1) {
                        that.taskid = res.data.data.taskid
                        that.startQuery()
                    }
                })
        },

        //销毁环境
        onDelete(record) {
            let that = this
            this.$store
                .dispatch({
                    type: 'kamanager/destroyaccount',
                    params: {
                        kaenv: record.kaenv,
                    },
                })
                .then((res) => {
                    if (res.data.success == 1) {
                        that.taskid = res.data.data.taskid
                        that.startQuery()
                    }
                })
        },
        startQuery() {
            let that = this
            that.tloading = true
            that.queryHandller = setInterval(function () {
                that.queryStatus()
            }, 3000)
        },

        //轮询任务状态
        queryStatus() {
            let that = this
            let queryType =
                that.taskid == 'buildJob'
                    ? 'kamanager/queryJobStatus'
                    : 'kamanager/queryTask'
            let queryParams = {
                taskid: that.taskid,
            }
            if (that.taskid == 'buildJob') {
                queryParams = that.tempParams
            }
            that.$store
                .dispatch({
                    type: queryType,
                    params: queryParams,
                })
                .then((res) => {
                    if (res.data.success == 1) {
                        if (that.taskid == 'buildJob') {
                            let status = res.data.data
                            // 枚举值
                            // FAILURE - 构建失败,
                            // UNSTABLE - 不稳定,
                            // REBUILDING - 重建中,
                            // BUILDING - 构建中,
                            // ABORTED - 已中止,
                            // SUCCESS - 构建成功,
                            // UNKNOWN - 未知状态,
                            // NOT_BUILT - 未构建,
                            // CANCELLED - 已取消;
                            if (status == 'SUCCESS' || status == 'CANCELLED') {
                                that.queryEnd()
                            }
                        } else {
                            let status = res.data.data.status // 0-执行中 1-执行成功 2-执行失败
                            if (status == 1 || status == 2) {
                                that.queryEnd()
                            }
                        }
                    }
                })
        },
        queryEnd() {
            let that = this
            that.tloading = false
            clearInterval(that.queryHandller)
            that.queryHandller = null
            that.pagination.page = 1
            that.getAppSumData()
            that.message.success('操作成功')
        },
        onModalHide() {
            this.getAppSumData()
        },
        handleEdit(record) {
            this.$refs.myItemModal.init({
                ...record,
            })
        },
        handleNew() {
            this.$refs.myItemModal.init({
                id: '',
            })
        },
        handleSearchReset() {
            this.searchP = {
                keyword: '',
            }
            this.pagination.page = 1
            this.getAppSumData()
        },
        handlePageChange(c_p) {
            this.pagination.page = c_p
            this.getAppSumData()
        },
        getAppSumData() {
            let that = this
            that.tloading = true
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'kamanager/queryaccountpage',
                    params: params,
                })
                .then((res) => {
                    that.tloading = false
                    let result = res.data.data
                    that.tableData = result.list
                    that.pagination.total = result.totalRecords
                    that.pagination.pageSize = result.pageSize
                    that.pagination.page = result.page
                })
                .catch(() => {
                    that.tloading = false
                })
        },
        handleSearch() {
            this.pagination.page = 1
            this.getAppSumData()
        },
    },
    mounted() {
        this.pagination.page = 1
        this.getAppSumData()
    },
}
</script>
